const Select = {
   parts: ['field', 'icon'],
   variants: {
      outline: {
         field: {
            _disabled: {
               bgColor: 'gray.100',
            },
            _invalid: {
               bgColor: 'red.50',
            },
         },
      },
   },
   sizes: {
      sm: {
         field: {
            borderRadius: 'md',
            minHeight: '28px',
            paddingInline: '8px',
         },
      },
      md: {
         field: {
            minHeight: '36px',
            paddingInline: '12px',
         },
      },
   },
};

export default Select;
